// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { menuActionCreators, userActionCreators } from '../../actions';
import useMergeProps from '../../hooks/useMergeProps';
import useRouter from '../../hooks/useRouter';

import MobileSportsMenu from './MobileSportsMenu';
import makeMobileSportsMenuPropsSelector from './MobileSportsMenu.selector';

const MobileSportsMenuContainer = () => {
  const {
    params: { sportId: stringSportId },
  } = useRouter();

  const dispatch = useDispatch();

  const selector = useMemo(() => makeMobileSportsMenuPropsSelector(), []);

  const selectedProps = useSelector((state) =>
    selector(state, { sportId: stringSportId ? parseInt(stringSportId, 10) : undefined }),
  );

  const actions = useMemo(() => bindActionCreators(menuActionCreators, dispatch), [dispatch]);
  const clearCalendarPreferences = useCallback(() => {
    dispatch(userActionCreators.clearPreferences('calendar'));
  }, [dispatch]);
  const clearFavoritePreferences = useCallback(() => {
    dispatch(userActionCreators.clearPreferences('favorites'));
  }, [dispatch]);

  const actionsProps = { actions, clearCalendarPreferences, clearFavoritePreferences };

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return <MobileSportsMenu {...enhancedProps} />;
};

export default MobileSportsMenuContainer;
